import React, { useCallback } from 'react';

import IconButton from 'components/partials/button/icon-button';
import Input from 'components/partials/input/input';

import Icons from 'assets/icons';

const formatCurrencyValue = (value: number | null): string =>
  value == null ? '' : Math.round(value).toLocaleString('en-US');

interface InputErrorsNames {
  message?: string;
  [key: string]: unknown;
}

export interface CurrencyFieldProps {
  label: string;
  labelFor: string;
  value: number | null;
  onChange: (value: number | null) => void;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  'data-testid'?: string;
  inputCustomClass?: string;
  errorsNames?: InputErrorsNames;
}

const CurrencyField = ({
  label,
  labelFor,
  value,
  onChange,
  required,
  disabled,
  placeholder,
  'data-testid': dataTestId = labelFor,
  inputCustomClass,
  errorsNames,
}: CurrencyFieldProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value.replace(/[^0-9]/g, '');

      onChange(raw ? Number.parseInt(raw, 10) : null);
    },
    [onChange]
  );

  const handleClear = useCallback(() => onChange(null), [onChange]);

  const showClear = value != null && !disabled;

  return (
    <Input
      label={label}
      labelFor={labelFor}
      labelInTop
      type="text"
      value={formatCurrencyValue(value)}
      startAdornment="$"
      endAdornment={
        showClear ? (
          <IconButton
            size="xs"
            variant="reserve-text"
            icon={<Icons.Close />}
            onClick={handleClear}
            aria-label={`Clear ${label}`}
            data-testid={`${dataTestId}-clear`}
          />
        ) : null
      }
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      onChange={handleChange}
      errorsNames={errorsNames}
      data-testid={dataTestId}
      inputCustomClass={inputCustomClass}
    />
  );
};

export default CurrencyField;
